import { Box } from '@mui/material';
import { styled as muiStyled } from '@mui/material/styles';
import { borderColor, borderRadius, boxSizing, display, fontFamily, fontSize, fontWeight, height, lineHeight, positions, width } from '@mui/system';
import { secondary } from 'styles/theme';
import { dark } from 'styles/theme';
import { thirdly2 } from 'styles/theme';
import { lightSecondary } from 'styles/theme';
import { thirdly4 } from 'styles/theme';
import { sidebar } from 'styles/theme';
import { thirdly5 } from 'styles/theme';
import { white } from 'styles/theme';
import { bg } from 'styles/theme';

export const ImageCellStyles = muiStyled(Box)(({ theme }) => ({
    width: 45,
    height: 45
}));

export const TicketsStyles = muiStyled(Box)(({ theme }) => ({
    overflow: "auto",
    flexGrow: 1,
    display: "flex",
    flexDirection: "column"
}));

export const WrapTabs = muiStyled(Box)(({ theme }) => ({
    position: "relative",
    top: 4,
    height: 49,
    '.wrap-divider': {
        position: "relative",
        bottom: 5
    }
}));

export const WrapTable = muiStyled(Box)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
}));

export const TicketsHeader = muiStyled(Box)(({ theme }) => ({
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    alignItems: "center",
    zIndex: 1
}));

export const TicketMessageStyles = muiStyled(Box)(({ theme }) => ({
    display: "flex",
    columnGap: 20,
    width: "100%",
    '.message-edited': {
        display: "flex",
        alignItems: "center",
        'path': {
            fill: "#26445A80"
        },
        '.MuiSvgIcon-root': {
            fontSize: 16
        }
    },
    '.update-date': {
        position: "relative",
        left: 20
    },
    '.wrap-update-date': {
        color: "#26445A80",
        fontSize: 16,
        display: "flex",
        flexDirection: "column",
        lineHeight: "17px"
    },
    '.superuser-chip': {
        display: "flex",
        marginTop: 5
    },
    '.ticket-message-image': {
        width: 100,
        height: 100
    },
    '.ticket-message-header': {
        display: "flex",
        columnGap: 10,
        width: 160
    },
    '.ticket-user-name': {
        fontWeight: "bold"
    },
    '.message-menu': {
        position: "relative",
        left: 10
    },
    '.message-content': {
        display: "flex",
        flexDirection: "column",
        rowGap: 15,
        flexGrow: 1
    },
    '.wrap-message-content': {
        background: "white",
        borderRadius: 5,
        padding: 20,
        whiteSpace: 'pre-wrap',
        display: "flex",
        flexGrow: 1
    }
}));

export const EmptyImageCell = muiStyled(Box)(({ theme }) => ({
    width: 45,
    height: 45,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: bg,
    borderRadius: 5
}));

export const PriorityCellStyles = muiStyled(Box)(({ theme }) => ({
    height: 45,
    display: "flex",
    alignItems: "center",
}));

export const StatusCellStyles = muiStyled(Box)(({ theme }) => ({
    height: 45,
    display: "flex",
    alignItems: "center"
}));


export const TicketStyles = muiStyled(Box)(({ theme }) => ({
    flexGrow: 1,
    overflow: "auto",
    display: "flex",
    flexDirection: "column",
    rowGap: 20,
    '.status-chip': {
        fontWeight: "normal"
    },
    '.update-ticket-status': {
        display: "flex",
        columnGap: 10,
        width: "100%",
    },
    '.image-field': {
        height: "100%"
    },
    '.image-preview': {
        width: "50px !important",
        height: "50px !important"
    },
    '.wrap-create-and-upload-file': {
        display: "flex",
        flexDirection: "column",
        alignItems: "space-between",
        width: 150,
        height: "100%"
    },
    '.message-box-and-button': {
        display: "flex",
        columnGap: 20,
        width: "70%",
        alignItems: "center",
        position: "relative",
        left: 100
    },
    '.wrap-message-box': {
        background: "white",
        position: "absolute",
        bottom: 0,
        width: `calc(100% - ${sidebar}px)`,
        left: sidebar,
        display: "flex",
        justifyContent: "center",
        padding: 20,
        height: 130,
        [theme.breakpoints.down('md')]: {
            width: "100%",
            left: 0
        }
    },
    'textarea': {
        width: "100%",
        boxSizing: "border-box",
        border: "none",
        borderRadius: 5,
        background: thirdly4,
        boxShadow: theme.shadows[1],
        fontSize: 18,
        fontFamily: [
            "Calibri", "sans-serif"
        ].join(','),
        padding: 10,
        boxSizing: "border-box"
    },
    '.create-ticket-message': {
        display: "flex",
        height: "100%",
        alignItems: "end"
    },
    '.wrap-ticket-messages': {
        flexGrow: 1,
        boxSizing: "border-box",
        overflow: "auto",
        height: "calc(100% - 165px)",
    },
    '.wrap-ticket-messages1': {
        width: "85%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        rowGap: 20
    },
    '.ticket-messages': {
        marginLeft: 35,
        display: "flex",
        flexDirection: "column",
        rowGap: 20
    },
    '.ticket-content': {
        padding: "0px 50px",
        boxSizing: "border-box",
        display: "flex",
        columnGap: 100,
        marginTop: 50,
        width: "100%",
        flexGrow: 1,
        overflow: "auto"
    },
    '.ticket-title': {
        fontSize: 19,
        fontWeight: "bold",
        height: 50
    },
    '.ticket-detail-list': {
        background: white,
        borderRadius: 5,
        overflow: "auto"
    },
    '.ticket-detail-list-content': {
        fontWeight: 700
    },
    '.ticket-detail-list-title': {
        color: "#26445A80"
    },
    '.ticket-detail-list-item': {
        padding: 15,
        display: "flex",
        flexDirection: "column",
        rowGap: 6
    },
    '.ticket-details': {
        height: "calc(100% - 165px)",
        width: 350,
        display: "flex",
        flexDirection: "column",
        rowGap: 20
    }
}));